import React from "react";

export const TermsText = () => {
  return (
    <div className="text-xs text-center text-light-black leading-5">
      {"By continuing, you agree to the "}
      <a
        href="http://goodvets.com/promotion-terms"
        target="_blank"
        rel="noreferrer"
      >
        <span className="font-semibold underline">
                    GoodVets Promotions
        </span>
      </a>
      <br />
      <a
        href="http://goodvets.com/terms"
        target="_blank"
        rel="noreferrer"
      >
        <span className="font-semibold underline">
                    Terms of Service
        </span>
      </a>
    </div>
  );
};
